import XLRLogger from 'src/common/helpers/logger';
import { shiftEnd } from './service/shift-end-service';

export const notifyShiftEnd = async (): Promise<void> => {
  await shiftEnd().catch(err => {
    XLRLogger.error({
      message: `ShiftEndCommand: Failed notifying cashier shift end, but continue execution. Ex :${err.Message}`,
      source: 'shift-end.ts',
    });
  });
};
